import { $themeBreakpoints } from "@themeConfig"

export default {
  namespaced: true,
  state: {
    windowWidth: 0,
    shallShowOverlay: false,
    isShowVeeam: false,
    veeamCurrentServer: {
      id: "",
      name: "",
    },
    veeamStatus: true,
    veeamServer: [{ id: "", name: "" }],
  },
  getters: {
    currentBreakPoint: (state) => {
      const { windowWidth } = state
      if (windowWidth >= $themeBreakpoints.xl) return "xl"
      if (windowWidth >= $themeBreakpoints.lg) return "lg"
      if (windowWidth >= $themeBreakpoints.md) return "md"
      if (windowWidth >= $themeBreakpoints.sm) return "sm"
      return "xs"
    },
    getCurrentServerVeeam(state) {
      if (!state.veeamCurrentServer) {
        state.veeamCurrentServer = {
          id: "",
          name: "",
        }
      }
      return state.veeamCurrentServer
    },
    getShowVeeam(state) {
      return state.isShowVeeam
    },
    getAllVeeamServer(state) {
      return state.veeamServer
    },
    getVeeamStatus(state) {
      return state.veeamStatus
    },
  },
  mutations: {
    UPDATE_WINDOW_WIDTH(state, val) {
      state.windowWidth = val
    },
    TOGGLE_OVERLAY(state, val) {
      state.shallShowOverlay = val !== undefined ? val : !state.shallShowOverlay
    },
    UPDATE_CURRENT_VEEAM_SERVER(state, value) {
      state.veeamCurrentServer = value
    },
    UPDATE_SHOW_VEEAM(state, value) {
      state.isShowVeeam = value
    },
    UPDATE_VEEAM_LIST(state, value) {
      state.veeamServer = value
    },
    UPDATE_VEEAM_STATUS(state, value) {
      state.veeamStatus = value
    },
  },
  actions: {
    setCurrentVeeamServer({ commit }, value) {
      commit("UPDATE_CURRENT_VEEAM_SERVER", value)
      sessionStorage.setItem("current-veeam-server", JSON.stringify(value))
      localStorage.setItem("current-veeam-server", JSON.stringify(value))
    },
    setShowVeeam({ commit }, value) {
      commit("UPDATE_SHOW_VEEAM", value)
    },
    setVeeamList({ commit }, value) {
      commit("UPDATE_VEEAM_LIST", value)
    },
    setVeeamStatus({ commit }, value) {
      commit("UPDATE_VEEAM_STATUS", value)
    },
  },
}
